import { Pipe, PipeTransform } from '@angular/core';

import { NO_VALUE } from '../';
import { FeatureConnectionService } from '../../services/feature-connection.service';

@Pipe({
  name: 'suffix',
})
export class SuffixPipe implements PipeTransform {
  constructor(private featureConnectionService: FeatureConnectionService) {}

  transform(value: any, ...args: any[]): string {
    if (value === null || value === undefined) {
      return NO_VALUE;
    }
    if (this.featureConnectionService.isErrorOrNotConnectedBasedOnTranslation(value)) {
      return value;
    }

    const suffix = args[0] || '';

    return `${value} ${suffix}`;
  }
}
